module.exports = __webpack_public_path__ + "img/logo_white.5f55f3c8.png";